module.exports = __webpack_public_path__ + "static/media/curio-circle.a27b159e.png";